import { render, staticRenderFns } from "./MapFrame.vue?vue&type=template&id=04d4c4bd"
import script from "./MapFrame.vue?vue&type=script&lang=js"
export * from "./MapFrame.vue?vue&type=script&lang=js"
import style0 from "./MapFrame.vue?vue&type=style&index=0&id=04d4c4bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports